import React from 'react'

const ReviewCard = () => {
  return (
    <div className=" w-full bg-[#f8fafc] px-6 py-10  md:p-16 rounded-2xl text-center  flex flex-col gap-4 items-center  ">
      <h3 className="sm_h3 md:h3 !font-medium">
        “We love Tradly because it offers our members a distraction-free place to network, learn and
        grow their business.”
      </h3>
      <img
        src="https://media.tradly.app/images/marketplace/47432/image-18-qoziCqvM.png"
        alt=""
        className=" w-14 h-14  rounded-full"
      />
      <p className=" text-lg font-bold">Jennifer Lee</p>
      <p className=" font-medium  text-lightGray">
        Customer Success and Community Manager, WebinarNinja
      </p>
    </div>
  )
}

export default ReviewCard
